const styles = ({ typography }) => ({
  ...typography.p,
  ...typography.p2,
  textAlign: 'right',
  width: '100%',
});

export default styles;
